import styled from 'styled-components';
import getTextColor from 'helpers/getTextColor';

export default styled.div`
  display: flex;
  overflow: hidden;
  border-radius: 2rem;
  height: 3rem;
  max-width: 21rem;
  margin: 0.5rem;
  font-size: 1rem;
  color:  ${props => props.$isActive ? (props.tagColor && !(props.tagColor.startsWith('rgba') && props.tagColor.endsWith('0)')) && props.tagColor.toLowerCase() !== 'transparent'? getTextColor(props.tagColor) : 'inherit') : 'inherit'};
  background: ${props => props.$isActive ? (props.tagColor ? props.tagColor : 'rgba(111, 88, 255, 1)') : props.innerColor};
  border: ${props => props.tagColor ? `1px solid ${props.tagColor}` : '1px solid rgba(111, 88, 255, 1)'};
  width: 100%;
  padding: 1rem 1.5rem;
  justify-content: center;
  align-items: center;
  ${ props => props.$hasPointer ? `cursor: pointer;` : ''}

  @media (min-width: 25em) {
    width: unset;
    ${props => props.thisDesktopStyles}
  }


  &:hover {    
    ${props => !props.hoverOff && !props.customHoverStyling
      ? `cursor: pointer;
        color: rgba(255, 98, 86, 1);
        border: 1px solid rgba(255, 98, 86, 1);
        background: rgba(255, 255, 255, 1);
        text-decoration: line-through;`
      : null
    }
  }

  ${props => props.$thisStyles}
`;
